import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Education from './components/Education';
import Certification from './components/Certification';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Footer from './components/Footer';
import PhotoGallery from './components/PhotoGallery';

function App() {
  return (
    <div className="min-h-screen bg-btc-void text-white">
      <a
        href="#hero"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[60] focus:rounded-full focus:bg-btc-orange focus:px-4 focus:py-3 focus:font-mono focus:text-xs focus:font-bold focus:uppercase focus:tracking-widest focus:text-btc-void"
      >
        Skip to content
      </a>
      <Navbar />
      <main>
        <Hero />
        <About />
        <Experience />
        <Education />
        <Certification />
        <Projects />
        <Skills />
        <PhotoGallery />
      </main>
      <Footer />
    </div>
  );
}

export default App;
